import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, CalendarDots } from "@phosphor-icons/react";
import InteractionsPanel from "@/components/InteractionsPanel";

export default function ReleaseDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [release, setRelease] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/releases/${id}`);
        setRelease(data);
      } catch (e) {
        toast.error("Lançamento não encontrado");
        navigate("/lancamentos");
      } finally {
        setLoading(false);
      }
    })();
  }, [id, navigate]);

  if (loading) return <div className="pt-32 text-center text-zinc-500 font-mono-accent text-xs">A CARREGAR...</div>;
  if (!release) return null;

  return (
    <div className="pt-20 max-w-4xl mx-auto px-5 lg:px-8 pb-24" data-testid="release-detail-page">
      <Link to="/lancamentos" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white mb-6">
        <ArrowLeft size={16} weight="bold" /> Voltar aos lançamentos
      </Link>

      <div className="grid md:grid-cols-[280px,1fr] gap-8">
        <div>
          {release.cover_url ? (
            <div className="aspect-[2/3] rounded-2xl overflow-hidden border border-white/10">
              <img src={release.cover_url} alt={release.title} className="w-full h-full object-cover" />
            </div>
          ) : (
            <div className="aspect-[2/3] rounded-2xl bg-gradient-to-br from-[#7209B7]/20 to-[#E63946]/20 grid place-items-center">
              <CalendarDots size={48} weight="duotone" className="text-[#7209B7]" />
            </div>
          )}
        </div>
        <div>
          <div className="font-mono-accent text-xs text-[#E63946] mb-2 flex items-center gap-2">
            <CalendarDots size={14} weight="bold" /> LANÇAMENTO
          </div>
          <h1 className="font-display text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">{release.title}</h1>
          <div className="mt-4 space-y-2">
            <div className="flex items-baseline gap-3">
              <span className="font-mono-accent text-xs text-zinc-500">DATA</span>
              <span className="font-display text-xl font-bold">
                {new Date(release.release_date).toLocaleDateString("pt-PT", { weekday: "long", day: "2-digit", month: "long", year: "numeric" })}
              </span>
            </div>
            {release.publisher && (
              <div className="flex items-baseline gap-3">
                <span className="font-mono-accent text-xs text-zinc-500">EDITORA</span>
                <span className="text-zinc-300">{release.publisher}</span>
              </div>
            )}
          </div>
        </div>
      </div>
      <InteractionsPanel entityType="releases" entityId={id} />
    </div>
  );
}
